export function getText(obj, attr, language) {
  if (obj === undefined)
    return '';

  const ml_attr = attr + '_ml';

  if (ml_attr in obj) {
    const ml_obj = obj[ml_attr]
    language = language.toLowerCase();

    // Default language will be spanish
    if (!(language in ml_obj))
      return ml_obj['es'];

    return obj[ml_attr][language];
  }

  return obj[attr];
}